var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityCreateTool = function SvgActivityCreateTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 34,
    viewBox: "0 0 37 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.13 29.819H9.734L3.073 12.256H0v-2.209h4.247l6.661 17.562h19.598l6.66-17.562h4.248v2.21h-3.073l-6.66 17.562H20.13ZM6.883 0h27.355l-6.535 22.094H14.207L6.883 0Zm2.704 2.21 5.859 17.675h10.967l5.229-17.676H9.587Z"
  })));
};
export default SvgActivityCreateTool;